<template>
  <footer class="footer">
    <nav>
      <CommonMenu direction="column" theme="dark"/>
    </nav>

  </footer>
</template>


<style lang="scss" scoped>
  .footer{
    background-color: #0e1c38;
    border-radius: var(--attendee-card-border-radius);
    min-height: 430px;
    padding: 40px;
    width: 100%;
  }
</style>




<script>

import CommonMenu from "../CommonMenu";

export default {
  components: {
    CommonMenu
  }
}
</script>